import type { DmScanPhoto, DmScanSummary } from '@odo/shared-ui';

export interface MarkupPhoto {
    key: string;
    label: string;
    thumbnailUrl: string;
    fullUrl: string;
}

// A photo with neither URL can't be shown or drawn on, so it is left out.
export function markupPhotos(photos: readonly DmScanPhoto[] | null | undefined): MarkupPhoto[] {
    return (photos ?? []).flatMap((photo, index) => {
        const fullUrl = photo.originalUrl ?? photo.previewUrl;
        if (!fullUrl) return [];
        return [
            {
                key: `${photo.step}-${index}`,
                label: photo.label,
                thumbnailUrl: photo.previewUrl ?? fullUrl,
                fullUrl
            }
        ];
    });
}

export function scanOptionLabel(scan: DmScanSummary, formattedDate: string): string {
    return scan.alignerIndex == null
        ? formattedDate
        : `${formattedDate} · Aligner ${scan.alignerIndex}`;
}
